<template>
	<div class="container">
		<el-container>
			<el-header class="header">
				<headers /></el-header>
			<el-container>
				<slider />
				<el-main>
					<div class="main_box">
						<div class="main_main">
							<!--页头-->
							<div class="page_header">
								{{ pageTitle }}
							</div>
							<!--页头-->
							<div class="page_main">
								<div class="training-record-page">
									<div class="card-block">
										<div class="block-header">
											<div class="block-title">
												Selected Training Records
											</div>
										</div>
								
										<el-table v-if="type != 'certification'" :data="selectedRecords" border class="custom-table" header-cell-class-name="table-header-cell" cell-class-name="table-body-cell">
											<el-table-column prop="username" label="User" min-width="220" sortable />
											<el-table-column prop="item_name" label="Training Item" min-width="380" sortable />
											<el-table-column prop="deadline" label="Training Due Date" min-width="180" sortable>
												<template slot-scope="scope">
													{{ initTime(scope.row.end_time) }}
												</template>
											</el-table-column>
											<el-table-column prop="needCert" label="Certification Required?" min-width="160" sortable>
												<template slot-scope="scope">
													{{ scope.row.is_certification == 1 ? 'Yes' : 'No' }}
												</template>
											</el-table-column>
											<el-table-column prop="purpose" label="Purpose" min-width="160" sortable>
												<template slot-scope="scope">
													{{ scope.row.purpose == 1 ? 'Initial Training' : 'Retraining' }}
												</template>
											</el-table-column>
										</el-table>
								
										<el-table v-else ref="recordTable" :data="trainingRecords" border>
											<el-table-column label="User" prop="username" min-width="120" sortable />
											<el-table-column label="Training Item" prop="item_name" min-width="180" sortable />
											<el-table-column label="Training Completion Date" prop="" min-width="180" sortable>
												<template slot-scope="scope">
													{{ scope.row.training_completed_date == 0 ? '' : scope.row.training_completed_date }}
												</template>
											</el-table-column>
											<el-table-column label="Purpose" prop="purpose" min-width="120" sortable>
												<template slot-scope="scope">
													{{ scope.row.purpose == 1 ? 'Initial Training' : 'Retraining' }}
												</template>
											</el-table-column>
											<el-table-column label="Certification Due Date" prop="" min-width="190" sortable>
												<template slot-scope="scope">
													{{ initTime(scope.row.certification_end_time) }}
												</template>
											</el-table-column>
											<el-table-column prop="method" label="Certification Method" min-width="150">
												<template slot-scope="scope">
													{{ scope.row.certification_method || '' }}
												</template>
											</el-table-column>
											<el-table-column label="Certification Evidence Files" min-width="240">
												<template slot-scope="scope">
													<ul class="file-list-inline">
														<li v-for="(file, index) in scope.row.image_list" :key="index" style="padding:4px 0;">
															<a :href="file.url" target="_blank">{{ file.name }}</a>
														</li>
													</ul>
												</template>
											</el-table-column>
										</el-table>
								
										<div class="form-section" v-if="type != 'certification'">
											<el-form label-position="top" :model="formData" :rules="formDataRules" ref="trainingForm" class="custom-form">
												<el-form-item prop="trainingType">
													<template slot="label">
														<span class="label-text">Training Type</span>
													</template>
													<el-select v-model="formData.trainingType" placeholder="Please select a training type" class="full-width">
														<el-option v-for="item in trainingTypeOptions" :key="item.value" :label="item.label" :value="item.value" />
													</el-select>
												</el-form-item>
								
												<el-form-item label="Does This Indicate the Requirement Has Been Met?" class="gray-input" prop="requirementMet">
													<el-select disabled v-model="formData.requirementMet" placeholder="Please select" class="full-width">
														<el-option label="Yes" :value="1" />
														<el-option label="No" :value="2" />
													</el-select>
												</el-form-item>
								
												<el-form-item v-if="type == 'train'" label="Training Completion Date" prop="completeDate">
													<el-date-picker v-model="formData.completeDate" type="date" placeholder="Select Date" value-format="yyyy-MM-dd" format="yyyy-MM-dd" class="full-width" />
												</el-form-item>
								
												<el-form-item v-if="type == 'train'" label="Training Comments" prop="comment">
													<el-input v-model="formData.comment" type="textarea" :rows="3" resize="none" />
												</el-form-item>
											</el-form>
										</div>
								
										<div class="form-section" v-else>
											<el-form ref="trainingForm2" label-position="top" :model="cerData" :rules="cerDataRules" class="custom-form">
												<el-form-item label="Certification Completion Date" prop="certification_completed_date">
													<el-date-picker v-model="cerData.certification_completed_date" type="date" placeholder="Select Date" value-format="yyyy-MM-dd" format="yyyy-MM-dd" class="full-width" />
												</el-form-item>
											</el-form>
										</div>
									</div>
								
									<!-- Related Training Items -->
									<div class="card-block">
										<div class="block-header">
											<div class="block-title">
												Related Training Items
											</div>
										</div>
								
										<el-table :data="relatedProjects" border class="custom-table" header-cell-class-name="table-header-cell" cell-class-name="table-body-cell">
											<el-table-column prop="item_name" label="Training Item Identifier" min-width="420" sortable />
											<el-table-column prop="leixing_name" label="Training Item Type" min-width="320" sortable />
											<el-table-column prop="latestEvaluation" label="Latest Training Effectiveness Evaluation" min-width="270" sortable>
												<template slot-scope="scope">
													<div v-if="scope.row.superviseinfo">
														<div v-if="scope.row.superviseinfo.status == 1">In Progress</div>
														<div v-if="scope.row.superviseinfo.status == 2">Completed</div>
														<div v-if="scope.row.superviseinfo.status == 9">Withdrawn</div>
													</div>
													<div v-else>N/A</div>
												</template>
											</el-table-column>
											<el-table-column label="Actions" width="80" align="center">
												<template slot-scope="scope">
													<el-link type="primary" :underline="false" @click="handleView(scope.row)">
														Details
													</el-link>
												</template>
											</el-table-column>
										</el-table>
								
										<div class="btn_el">
											<div class="tips">
												You can assign a person to follow up with these users and evaluate the overall effectiveness of the training they received. Please note that this is intended to measure the overall quality of training delivered for a specific training item, rather than evaluating the competency of individual users.
											</div>
										</div>
								
										<div class="tip-box mt-16">
											<div class="tip-title">
												Please specify whether the effectiveness of these training items should be evaluated. If so, specify who should perform the evaluation and when the evaluation task should be completed.
											</div>
											<ul class="tip-list">
												<li>
													The following user help link will be displayed to the assigned evaluator, providing general guidance on measuring training effectiveness.
												</li>
												<li>
													Please use the "Training Effectiveness Evaluation Guidelines" field to provide specific instructions on how to evaluate the effectiveness of this training.
												</li>
											</ul>
										</div>
									</div>
								
									<div class="bottom-form-section">
										<el-form ref="evaluateForm" :model="evaluateForm" :rules="evaluateRules" label-position="top" class="custom-form">
								
											<el-form-item label="Assign a Task to Evaluate Training Effectiveness?" prop="assignTask" required>
												<el-select v-model="evaluateForm.assignTask" placeholder="Please select" class="full-width">
													<el-option label="Yes" :value="1" />
													<el-option label="No" :value="2" />
												</el-select>
											</el-form-item>
								
											<el-form-item v-if="canEditEvaluateFields" label="Task Owner" prop="owner">
												<el-input v-model="userName" placeholder="Please select a user" readonly @click.native="openUserDialog">
													<i slot="suffix" class="el-input__icon el-icon-user"></i>
												</el-input>
											</el-form-item>
								
											<el-form-item v-if="canEditEvaluateFields" label="Task Due Date" prop="dueDate">
												<el-date-picker v-model="evaluateForm.dueDate" type="date" placeholder="Select Date" value-format="yyyy-MM-dd" format="yyyy-MM-dd" class="full-width" />
											</el-form-item>
								
											<el-form-item v-if="canEditEvaluateFields" label="Training Effectiveness Evaluation Guidelines" prop="guide">
												<el-input v-model="evaluateForm.guide" type="textarea" :rows="4" resize="none" />
											</el-form-item>
								
											<div class="upload-doc-wrapper" v-if="type == 'train'">
												<div class="upload-title">
													Training Evidence Files
													<span class="upload-limit">(Maximum 10 MB)</span>
												</div>
								
												<div class="upload-box">
													<el-upload
														ref="uploadBox"
														class="doc-upload"
														action="/api/trainUploads"
														name="files"
														:data="uploadData"
														:headers="{ token: userToken }"
														:show-file-list="false"
														:before-upload="beforeAvatarUpload"
														:on-success="handleAvatarSuccess"
														:limit="1"
														:with-credentials="true">
								
														<el-button size="medium" class="select-btn">
															Select File
														</el-button>
								
													</el-upload>
								
													<div class="file-name" :class="{ placeholder: !fileName }">
														{{ fileName || "No file selected" }}
														<span v-if="fileName" style="position:absolute;right:20px;top:12px;cursor:pointer;color:#f00;" @click="delFile">
															Delete
														</span>
													</div>
												</div>
											</div>
								
											<el-form-item v-if="type != 'assignment'" label="Signature" prop="signature" required>
												<el-input v-model="evaluateForm.signature" placeholder="Please enter" clearable show-password />
											</el-form-item>
								
										</el-form>
								
										<div class="action-btns">
											<el-button type="primary" @click="handleSubmit">
												Confirm
											</el-button>
											<el-button type="primary" @click="handleCancel">
												Cancel
											</el-button>
										</div>
									</div>
								</div>
							</div>
						</div>
					</div>
				</el-main>
			</el-container>
		</el-container>
		<!-- 选择人员弹窗 -->
		<UserSelect :visible.sync="dialogVisible" :user-list="userList" :selected-id="selectedId"
		@confirm="handleConfirm" />
		<!-- 选择人员弹窗 -->
		<!--loading-->
		<transition name="fade">
			<div class="loading" v-show="isLoading">
				<van-loading /></div>
		</transition>
		<!--loading-->
	</div>
</template>

<script>
import {
	trainCompleteDetail,
	trainComplete,
	trainAssigned,
	trainCertificationComplete
} from '@/api/trainManage/configTrain/trainRecord/index';
import headers from "@/component/header.vue";
import slider from "@/component/slider.vue";
import UserSelect from "@/component/user-select.vue";
import { usersList } from "../../../../api/system/user";
import moment from 'moment';
import md5 from 'js-md5';
export default {
	components: {
		headers,
		slider,
		UserSelect,
	},
	data() {
		return {
			isLoading: true,
			fileName: '',
			selectedFile: null,
			uploadData: {
				train_leixing: ''
			},
			userName: "",
			selectedId: null,
			dialogVisible: false,
			userList: [],
			formData: {
				trainingType: '',
				requirementMet: 1,
				completeDate: "",
				comment: "",
			},
			formDataRules: {
				trainingType: [{ required: true, message: "Please select", trigger: "change" }],
				requirementMet: [{ required: true, message: "Please select", trigger: "change" }],
				completeDate: [{ required: true, message: "Please select", trigger: "change" }]
			},
			cerData: {
				certification_completed_date: "",
			},
			cerDataRules: {
				certification_completed_date: [{ required: true, message: "Please select", trigger: "change" }],
			},
			evaluateForm: {
				assignTask: 2,
				owner: '',
				dueDate: '',
				guide: '',
				signature: '',
			},
			evaluateRules: {
				assignTask: [{ required: true, message: "Please select", trigger: "change" }],
				owner: [{ required: true, message: "Please select", trigger: "change" }],
				dueDate: [{ required: true, message: "Please select", trigger: "change" }],
				guide: [{ required: true, message: "Please enter", trigger: "blur" }],
				signature: [{ required: true, message: "Please enter", trigger: "blur" }],
			},
			trainingTypeOptions: [
				{ label: "External Training", value: 1 },
				{ label: "Internal Training", value: 2 },
				{ label: "Online Training", value: 3 }
			],
			trainingRecords: [],
			selectedRecords: [],
			relatedProjects: [],
			userToken: localStorage.getItem("userToken"),
			type: "",
			trainIds: "",
			infoData: null
		};
	},
	created() {
		let that = this;
		that.type = that.$route.query.type;
		that.trainIds = that.$route.query.ids;
		//上传文件附带数据
		if(that.type == 'train') {
			that.uploadData.train_leixing = 1;
		}else {
			that.uploadData.train_leixing = 2;
		}
	},
	mounted() {
		let that = this;
		// 请求页面数据
		trainCompleteDetail({ ids: that.trainIds }).then(res => {
			if(res.code == 200) {
				usersList({
					page: 1,
					page_size: 99999
				}).then((res2) => {
					if (res2.code == 200) {
						that.infoData = res.data;
						that.userList = res2.data.data;
						that.isLoading = false;
						that.relatedProjects = that.infoData.requirements_list;
						that.selectedRecords = that.infoData.train_list;
						that.trainingRecords = that.infoData.train_list;
						// console.log(that.infoData);
					}
				});
			}
		});
	},
	computed: {
		canEditEvaluateFields() {
			let that = this;
			return that.evaluateForm.assignTask == 1;
		},
		pageTitle() {
			let that = this;
			switch (that.type) {
			case "train":
				return "Mark Training as Completed";
				break;
			case "assignment":
				return "Assign User to Complete Training";
				break;
			case "certification":
				return "Mark Certification as Completed";
				break;
			}
		},
	},
	methods: {
		//时间戳转换
		initTime(value) {
			if(value) {
				return moment(value * 1000).format('YYYY-MM-DD');
			}
		},
		handleView(row) {
			let that = this;
			const routeData = that.$router.resolve({ path: '/TrainControl/record-detail', query: { id: row.id } });
			window.open(routeData.href, "_blank");
		},
		handleAvatarSuccess(res, file) {
			let that = this;
			if (!file && !res) return;
			that.selectedFile = res.data.id;
			that.fileName = res.data.name;
			that.$toast.clear();
		},
		beforeAvatarUpload(file) {
			let that = this;
			const maxSize = 10 * 1024 * 1024; // 10MB
			const isLt100M = file.size <= maxSize;
			if(!isLt100M) {
				that.$message.error("Training file size must not exceed 10 MB");
				return false;
			}
			that.$toast.loading({ duration: 0, forbidClick: true });
		},
		//删除文件
		delFile() {
			let that = this;
			that.selectedFile = '';
			that.fileName = '';
			that.$refs.uploadBox.clearFiles();
		},
		handleSubmit() {
			let that = this;
			//标记培训完成(trainComplete)
			if(that.type == 'train'){
				that.$refs.trainingForm.validate((valid1) => {
					if (!valid1) return;
					that.$refs.evaluateForm.validate((valid2) => {
						if (!valid2) return;
						let query = {
							ids: that.trainIds,
							train_leixing_id: that.formData.trainingType,
							is_meet: that.formData.requirementMet,
							training_completed_date: moment(that.formData.completeDate).valueOf() / 1000,
							training_comments: that.formData.comment,
							is_training_assigning: that.evaluateForm.assignTask,
							task_lead: that.evaluateForm.assignTask == 1 ? that.evaluateForm.owner : '',
							task_end_time: that.evaluateForm.assignTask == 1 ? moment(that.evaluateForm.dueDate).valueOf() / 1000 : '',
							effectiveness_evaluation_guidelines: that.evaluateForm.assignTask == 1 ? that.evaluateForm.guide : '',
							training_files: that.evaluateForm.assignTask == 1 ? that.selectedFile : '',
							signature: md5(that.evaluateForm.signature+'AiisoQms2026')
						};
						that.$toast.loading({ duration: 0, forbidClick: true });
						trainComplete(query).then(res => {
							if(res.code == 200) {
								that.$toast.clear();
								that.$message.success('Operation completed successfully');
								setTimeout(() => {
									that.$router.back();
								}, 800);
							}
						});
					});
				});
			}else if(that.type == 'assignment') {
				//指派用户完成自身培训(trainAssigned)
				that.$refs.trainingForm.validate((valid1) => {
					if (!valid1) return;
					that.$refs.evaluateForm.validate((valid2) => {
						if (!valid2) return;
						let query = {
							ids: that.trainIds,
							train_leixing_id: that.formData.trainingType,
							is_meet: that.formData.requirementMet,
							is_training_assigning: that.evaluateForm.assignTask,
							task_lead: that.evaluateForm.assignTask == 1 ? that.evaluateForm.owner : '',
							task_end_time: that.evaluateForm.assignTask == 1 ? moment(that.evaluateForm.dueDate).valueOf() / 1000 : '',
							effectiveness_evaluation_guidelines: that.evaluateForm.assignTask == 1 ? that.evaluateForm.guide : ''
						};
						that.$toast.loading({ duration: 0, forbidClick: true });
						trainAssigned(query).then(res => {
							if(res.code == 200) {
								that.$toast.clear();
								that.$message.success('Operation completed successfully');
								setTimeout(() => {
									that.$router.back();
								}, 800);
							}
						});
					});
				});
			}else if(that.type == 'certification') {
				//标记认证完成
				that.$refs.trainingForm2.validate((valid1) => {
					if (!valid1) return;
					that.$refs.evaluateForm.validate((valid2) => {
						if (!valid2) return;
						let query = {
							ids: that.trainIds,
							certification_completed_date: moment(that.cerData.certification_completed_date).valueOf() / 1000,
							is_training_assigning: that.evaluateForm.assignTask,
							task_lead: that.evaluateForm.assignTask == 1 ? that.evaluateForm.owner : '',
							task_end_time: that.evaluateForm.assignTask == 1 ? moment(that.evaluateForm.dueDate).valueOf() / 1000 : '',
							effectiveness_evaluation_guidelines: that.evaluateForm.assignTask == 1 ? that.evaluateForm.guide : '',
							signature: md5(that.evaluateForm.signature+'AiisoQms2026')
						};
						that.$toast.loading({ duration: 0, forbidClick: true });
						trainCertificationComplete(query).then(res => {
							if(res.code == 200) {
								that.$toast.clear();
								that.$message.success('Operation completed successfully');
								setTimeout(() => {
									that.$router.back();
								}, 800);
							}
						});
					});
				});
			}
		},
		openUserDialog() {
			let that = this;
			that.dialogVisible = true;
		},
		handleConfirm({
			id,
			user
		}) {
			let that = this;
			that.selectedId = id || null;
			that.evaluateForm.owner = id || null;
			that.userName = user ? user.username: "";
		},
		handleCancel() {
			let that = this;
			that.$router.back();
		},
		//跳转页面
		goUrl(url) {
			let that = this;
			that.$router.push(url);
		},
	},
};
</script>

<style lang="less" scoped>
//主要内容
.main_main {
  .page_main {
    padding: 18px 20px;
    .btn_el {
      margin: 10px 0 20px 0;
      .tips {
        padding: 6px 8px;
        background-color: #ffb1001a;
        border-radius: 6px;
        font-size: 16px;
        font-weight: bold;
      }
    }
  }
  //页头
  .page_header {
    padding: 0 20px;
    height: 60px;
    line-height: 60px;
    background-color: #d8e4f0;
    font-size: 24px;
    font-weight: bold;
    box-shadow: 0 2px 4px rgba(0, 0, 0, 0.075);
  }
}
</style>
<style scoped>
.main_box {
  height: calc(100vh - 60px);
  overflow-y: auto;
}

.main_box .main_main {
  position: relative;
  min-height: 100%;
  background-color: #fafafa;
}

.el-header,
.el-main {
  padding: 0;
}

.training-record-page {
  padding: 10px 14px 30px;
  background: #ffffff;
  color: #303133;
  box-sizing: border-box;
}

.block-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-bottom: 0;
  padding: 0;
}

.block-title {
  font-size: 28px;
  font-weight: 700;
  color: #222;
  margin-bottom: 10px;
}

.custom-table {
  margin-top: 8px;
  width: 100%;
}

::v-deep .table-header-cell {
  background: #fff !important;
  color: #222;
  font-size: 16px;
  font-weight: 700;
}

::v-deep .table-body-cell {
  font-size: 14px;
  color: #333;
}

.tip-box {
  background-color: #ffb1001a;
  border-radius: 6px;
  padding: 6px 8px;
  color: #333;
  font-size: 15px;
  line-height: 1.7;
}

.tip-title {
  margin-bottom: 6px;
  font-size: 16px;
  font-weight: bold;
}

.tip-list {
  margin: 0;
  padding-left: 22px;
}

.tip-list li {
  line-height: 1.8;
}

.form-section {
  margin-top: 14px;
}

.custom-form {
  width: 100%;
}

.label-text {
  margin-right: 8px;
  font-weight: 600;
  color: #333;
}

.full-width {
  width: 100%;
}

.mt-16 {
  margin-top: 16px;
}

.bottom-form-section {
  margin-top: 26px;
}

.action-btns {
  display: flex;
  justify-content: center;
}

.upload-doc-wrapper {
  width: 100%;
  margin-bottom: 40px;
  box-sizing: border-box;
}

.upload-title {
  font-size: 16px;
  color: #333;
  margin-bottom: 14px;
  font-weight: 500;
}

.upload-limit {
  color: #666;
  font-weight: 400;
}

.upload-box {
  display: flex;
  align-items: center;
  width: 100%;
  height: 44px;
  border: 1px solid #dcdfe6;
  border-radius: 6px;
  overflow: hidden;
  background: #f5f7fa;
}

.doc-upload {
  flex-shrink: 0;
}

.file-name {
  flex: 1;
  height: 44px;
  line-height: 44px;
  padding: 0 16px;
  font-size: 15px;
  color: #333;
  background: #f5f7fa;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  position: relative;
}

.file-name.placeholder {
  color: #999;
}

::v-deep .el-input__inner,
::v-deep .el-textarea__inner {
  border-radius: 6px;
}

::v-deep .el-select {
  width: 100%;
}

::v-deep .el-form-item__label {
  padding-bottom: 8px;
  color: #222;
  font-size: 15px;
}

::v-deep .el-table .cell {
  line-height: 1.5;
}

.gray-input ::v-deep .el-input__inner {
  background: #e9ecef;
  border: 1px solid #cfd5db;
  color: #2f343b;
  border-radius: 8px;
  height: 40px;
  line-height: 40px;
  font-size: 14px;
}

.gray-input ::v-deep .el-input__inner[readonly] {
  cursor: default;
}

::v-deep .btn span {
  text-decoration: underline;
}
</style>

